import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  width: 100%;
  min-width: 600px;
  display: flex;
  flex-direction: column;

  gap: 1.5rem;

  margin: 1.2rem 0;
`;

export default Container;
